import { render } from "./multiUnitModel.vue?vue&type=template&id=36b5ee0d"
import script from "./multiUnitModel.vue?vue&type=script&lang=js"
export * from "./multiUnitModel.vue?vue&type=script&lang=js"

import "./multiUnitModel.vue?vue&type=style&index=0&id=36b5ee0d&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__